import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import React from 'react';
import { getStockColor, StockDetail } from '.';
import { optionsHomepage } from './config';

interface HomepageChart {
  stockData: Array<StockDetail>;
  height?: number;
  prevClose: number;
  todayHigh: number;
  todayLow: number;
  className?: string;
}
const StockChartHomepage: React.FC<HomepageChart> = ({
  stockData,
  height = 120,
  prevClose,
  todayHigh,
  todayLow,
  className = '',
}) => {
  const stockColor = getStockColor(stockData);
  const stockOptions = optionsHomepage(
    [...stockData],
    stockColor,
    prevClose,
    todayHigh,
    todayLow,
    height
  );
  return (
    <div className={className}>
      <HighchartsReact highcharts={Highcharts} options={{ ...stockOptions }} />
    </div>
  );
};

export { StockChartHomepage };
